import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { SurgeonsPage } from '../../../features/entity-management';

export const Route = createFileRoute('/_auth/entity-management/surgeons')({
  staticData: {
    title: 'pages.entityManagement.title',
    description: 'pages.entityManagement.description',
  },
  component: SurgeonsRoute,
});

function SurgeonsRoute() {
  return (
    <Box
      sx={{
        px: { xs: '1rem', md: '1.5rem', lg: '3rem', xl: '3rem' },
        pb: '1.5rem',
      }}
    >
      <SurgeonsPage />
    </Box>
  );
}
